export default __webpack_public_path__ + "static/media/s3_bubble_right.538cfbf2.png";